import { createAxiosWithOauth2Handling } from 'app/common/authHelper';
import { BOOK_API_BASE_URL } from 'app/common/constants/defaultUrl';

export const getBooks = (bookIds: string[]) =>
  createAxiosWithOauth2Handling().get(
    `${BOOK_API_BASE_URL}/books?b_ids=${bookIds.join()}`, { withCredentials: false }
  );



// WEBPACK FOOTER //
// ./common/api/book.ts